export default __webpack_public_path__ + "static/img/icon-tutorial-hotspot.21dea32.png";